// Components
import { ShipmentOptionsTable } from "./ShipmentOptionsTable";
import { ShipmentOptionsShippingServiceSelect } from "./ShipmentOptionsShippingServiceSelect";

// Utils
import { currencyFormatter } from "../../utils/Utils";

// MUI Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export const ShipmentOptionsGroup = ({
  shipmentNo,
  shipment,
  staff,
  shippingServices,
  setShipment,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={2} component={Paper} elevation={2} sx={{ p: 2 }}>
        <Typography sx={{ fontWeight: "bold" }}>
          Shipment {shipmentNo} - Estimated despatch date is {shipment.date}
        </Typography>

        <ShipmentOptionsTable
          lines={shipment.lines}
          staff={staff}
          shipmentDate={shipment.date}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Stack
            component={Paper}
            elevation={3}
            spacing={2}
            sx={{
              minWidth: { md: "400px" },
              p: 2,
            }}
          >
            <Typography variant="subtitle2">
              Shipment Subtotal: {currencyFormatter("GB", shipment.subtotal)}
            </Typography>

            <ShipmentOptionsShippingServiceSelect
              shipment={shipment}
              setShipment={setShipment}
              services={shippingServices}
            />

            <Typography variant="subtitle2">
              Shipment Total:{" "}
              {shipment.shipping.index === ""
                ? "Please select a shipping service"
                : currencyFormatter("GB", shipment.total)}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
